import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background-50/90 backdrop-blur-md border-b border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-file-list-3-line text-background-50 text-lg"></i>
            </div>
            <span className="font-heading text-xl font-semibold text-foreground-900 whitespace-nowrap">
              Sugargoo Sheet
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-6">
            <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap">
              Home
            </Link>
            <Link to="/article/sugargoo-shipping-guide" className="text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap">
              Shopping Guide
            </Link>
            <a href="#categories" className="text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap">
              Categories
            </a>
            <a href="#articles" className="text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap">
              Articles
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-sm font-semibold px-5 py-2.5 bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>
          </nav>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 max-h-[70vh] overflow-y-auto">
          <div className="px-4 py-4 flex flex-col gap-1">
            <Link
              to="/"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors"
            >
              <div className="w-7 h-7 flex items-center justify-center bg-primary-100 rounded-lg">
                <i className="ri-home-4-line text-primary-600 text-sm"></i>
              </div>
              Home
            </Link>

            <Link
              to="/article/sugargoo-shipping-guide"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors"
            >
              <div className="w-7 h-7 flex items-center justify-center bg-accent-100 rounded-lg">
                <i className="ri-guide-line text-accent-600 text-sm"></i>
              </div>
              Shopping Guide
            </Link>

            <a
              href="#categories"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors"
            >
              <div className="w-7 h-7 flex items-center justify-center bg-secondary-100 rounded-lg">
                <i className="ri-grid-line text-secondary-600 text-sm"></i>
              </div>
              Categories
            </a>

            <a
              href="#articles"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors"
            >
              <div className="w-7 h-7 flex items-center justify-center bg-accent-100 rounded-lg">
                <i className="ri-article-line text-accent-600 text-sm"></i>
              </div>
              Articles
            </a>

            <div className="my-2 border-t border-background-200/60"></div>

            <p className="px-3 py-1 text-xs font-semibold text-foreground-400 uppercase tracking-wider">
              Shop Categories
            </p>

            {categories.map((cat) => (
              <a
                key={cat.id}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                onClick={() => setMobileOpen(false)}
                className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-foreground-600 hover:bg-background-100 transition-colors"
              >
                <div className="w-7 h-7 flex items-center justify-center bg-background-200/70 rounded-lg">
                  <i className={`${cat.icon} text-foreground-500 text-xs`}></i>
                </div>
                {cat.name}
              </a>
            ))}

            <div className="my-2 border-t border-background-200/60"></div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center justify-center gap-2 mx-3 mt-2 px-5 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-full text-center whitespace-nowrap"
            >
              Buy It Now
              <i className="ri-external-link-line"></i>
            </a>

            <Link
              to="/"
              onClick={() => setMobileOpen(false)}
              className="flex items-center justify-center gap-2 mx-3 mt-1 px-5 py-3 bg-background-100 text-foreground-700 font-semibold text-sm rounded-full text-center whitespace-nowrap"
            >
              Sugargoo Spreadsheet Home
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}